module.exports = __webpack_public_path__ + "static/media/pro-2.4cc308b7.jpg";